import { cn } from '@/utils';

function ProccessSpinner({ className, size = 40, ...props }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			height={size}
			width={size}
			viewBox="0 0 43 43"
			fill="none"
			className={cn('animate-spin', className)}
			{...props}
		>
			<circle cx="21.5" cy="21.5" r="20" stroke="#DEDEDF" strokeWidth="2" />
			<path
				d="M41.5 21C41.5 9.9543 32.5457 1 21.5 1C10.4543 1 1.5 9.9543 1.5 21C1.5 32.0457 10.4543 41 21.5 41"
				stroke="#EC4C38"
				strokeWidth="2"
			/>
		</svg>
	);
}

export default ProccessSpinner;
